import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'
import I18NextVue from 'i18next'

const weekdayMap: {
  // eslint-disable-next-line no-unused-vars
  [key in Extract<Filters['timeWork'], { type: 'custom' }>['weekday']]: string
} = {
  monday: 'Пн',
  tuesday: 'Вт',
  wednesday: 'Ср',
  thursday: 'Чт',
  friday: 'Пт',
  saturday: 'Сб',
  sunday: 'Вс',
}

const { t, language } = I18NextVue
const options = { ns: language }

function getTimeWorkLabel({ timeWork }: { timeWork: Filters['timeWork'] }) {
  if (timeWork.type === 'custom') {
    return `${t('Открыто в', options)} ${t(weekdayMap[timeWork.weekday], options)}, ${timeWork.time.from} — ${timeWork.time.to}`
  }

  if (timeWork.type === '24_7') {
    return 'Круглосуточно'
  }

  if (timeWork.type === 'open_now') {
    return 'Открыто сейчас'
  }
}

export default getTimeWorkLabel
